import {createContext} from 'react';
import defaultConfig from 'src/internal/config/defaultConfig';

import type {ObservabilityConfig} from 'src/types';

export default createContext<ObservabilityConfig>(defaultConfig);
